import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

interface DrinkTrialModalProps {
  open: boolean;
  onClose: () => void;
}

export function DrinkTrialModal({ open, onClose }: DrinkTrialModalProps) {
  const { t } = useLanguage();

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-center">{t('drinkTrialModalTitle')}</DialogTitle>
          <DialogDescription className="text-center pt-2">
            {t('drinkTrialModalDesc')}
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center pt-2">
          <Button onClick={onClose} variant="default">
            {t('drinkTrialModalBtn')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
